// @flow

export const INSTRUCTOR_ACCOUNT_FORM: string = "instructorAccount";
export const CANCELLATION_POLICY_FORM: string = "cancellationPolicy";
